module.exports = __webpack_public_path__ + "img/cabin.f0695fd5.jpg";